import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { MobileApp } from '../../../../SideBar/SettingsModal/MobileApp';
import { SETTING_ICONS } from '../../../constants';
import './MobileAppSection.scss';

const MobileAppSection: FC = () => {
  const Icon = SETTING_ICONS.mobile;
  const { t } = useTranslation();

  return (
    <div className="mobile-app-section mobile-app-section--new-tabs">
      <div className="mobile-app-section__block">
        <Stack gap={1} direction="row" alignItems="center">
          <Icon className="mobile-app-section__section-icon" />
          <Typography variant="body1" className="mobile-app-section__section-title">
            {t('settings.productHub.mobileApp')}
          </Typography>
        </Stack>
        <MobileApp />
      </div>
    </div>
  );
};

export default MobileAppSection;
